// extracted by mini-css-extract-plugin
export default {"text":"HomeMenuBtnInformText_text__kFuB0"};